export function validatePhone(valideStr) {
  let reg = /^1\d{10}$/
  return reg.test(valideStr)
}

export function validateCert(valideStr) {
  let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  return reg.test(valideStr)
}

